<template>
  <div>
    <tripwiseHeader :type='1'></tripwiseHeader>
    <div class="banner">
      <img class="bannerBg" src="https://image.ceekee.com/pc/secondwebsite/home_bg.png" />
      <img class="app-index" src="https://image.ceekee.com/pc/secondwebsite/home_mockup.png" />
      <div class="banner-intro">
        <div class="customer-info">
          <img src="https://image.ceekee.com/pc/secondwebsite/title_home.png?v=1" />
        </div>
        <div class="b-flex b-flex-row">
          <div @click="toGet" class="button1 b-flex b-justify-center b-align-centenr">立即获取</div>
          <div @click="toGet" class="button2 b-flex b-justify-center b-align-centenr">查看更多</div>
        </div>
      </div>
    </div>
    <div class="content b-flex b-flex-column b-align-centenr">
      <span class="title">一站式满足企业全场景消费管理需求</span>
      <span class="sub-title">差旅场景</span>
      <div class="travel b-flex b-flex-row">
        <div class="travel-item travel-margin">
          <div class="travel-title">机票</div>
          <img class="travel-jipiao" src="https://image.ceekee.com/pc/secondwebsite/home_plane.png" />
        </div>
        <div class="travel-item travel-margin">
          <div class="travel-title">酒店</div>
          <img
            class="travel-jiudian"
            src="https://image.ceekee.com/pc/secondwebsite/home_jiudian.png"
          />
        </div>
        <div class="travel-item travel-margin">
          <div class="travel-title">火车票</div>
          <img
            class="travel-huoche"
            src="https://image.ceekee.com/pc/secondwebsite/home_huoche.png"
          />
        </div>
        <div class="travel-item">
          <div class="travel-title">用车</div>
          <img
            class="travel-yongche"
            src="https://image.ceekee.com/pc/secondwebsite/home_yongche.png"
          />
        </div>
      </div>
      <div class="travel travel-second-row b-flex b-flex-row">
        <div class="travel-item travel-margin">
          <div class="travel-title">差标配置</div>
          <img
            class="travel-chaibiao"
            src="https://image.ceekee.com/pc/secondwebsite/home_chaibiao.png"
          />
        </div>
        <div class="travel-item travel-margin">
          <div class="travel-title">审批配置</div>
          <img
            class="travel-shenpi"
            src="https://image.ceekee.com/pc/secondwebsite/home_shenpi.png"
          />
        </div>
        <div class="travel-item travel-margin">
          <div class="travel-title">预算管理</div>
          <img
            class="travel-yusuan"
            src="https://image.ceekee.com/pc/secondwebsite/home_yusuan.png"
          />
        </div>
      </div>
      <span class="other-title">其他场景</span>
      <div class="other-view">
        <img class="other-image" src="https://image.ceekee.com/pc/secondwebsite/home_qita.png" />
      </div>
      <div class="process">
        <span class="left-title">差旅场景</span>
        <div class="title process-title b-flex b-justify-center">精细的差旅流程管控</div>
        <div class="process-info b-flex b-justify-center">
          <img src="https://image.ceekee.com/pc/secondwebsite/home_guankong02.png" />
        </div>
      </div>
    </div>
    <div class="resources b-flex b-flex-row b-align-centenr b-justify-center">
      <div class="resources-info">
        <div class="resources-title">优质的差旅资源</div>
        <div class="resource-detail b-flex b-flex-row b-align-centenr">
          <img
            class="resources-icon"
            src="https://image.ceekee.com/pc/secondwebsite/home_ziyuan_jipiao.png"
          />
          <div class="resources-content">
            <span class="product">机票：</span>覆盖全球航线；商旅独享价格优势，
            <span class="discount">90%</span>低于OTA；支持大客户协议价
          </div>
        </div>
        <div class="resource-detail b-flex b-flex-row b-align-centenr">
          <img
            class="resources-icon"
            src="https://image.ceekee.com/pc/secondwebsite/home_ziyuan_jiudian.png"
          />
          <div class="resources-content">
            <span class="product">酒店：</span>覆盖全球170万家酒店；支持绑定个人账号同步积分；享有
            <span class="discount">7.5</span> 折—
            <span class="discount">8.5</span> 折预订
          </div>
        </div>
        <div class="resource-detail b-flex b-flex-row b-align-centenr">
          <img
            class="resources-icon"
            src="https://image.ceekee.com/pc/secondwebsite/home_ziyuan_huoche.png"
          />
          <div class="resources-content">
            <span class="product">火车：</span>直连12306；支持预订、抢票、退改；享有高铁贵宾政策
          </div>
        </div>
        <div class="resource-detail b-flex b-flex-row b-align-centenr">
          <img
            class="resources-icon"
            src="https://image.ceekee.com/pc/secondwebsite/home_ziyuan_yongche.png"
          />
          <div class="resources-content">
            <span class="product">用车：</span>聚合多供应商打车；满足商旅出行、员工加班等多场景需求
          </div>
        </div>
      </div>
      <img class="resource-img" src="https://image.ceekee.com/pc/secondwebsite/home_ziyuan.png" />
    </div>
    <div class="content module b-flex b-flex-column b-align-centenr">
      <div class="right-back"></div>
      <div class="module-title">
        行业<span class="title-color">独家</span>资源及模式
      </div>
      <span class="module-intro">Tripwise 是行业唯一，可同步四大平台C端会员价的差旅平台，实现C端价格和B端价格的共享，</span>
      <span class="module-intro">Tripwise 将为您选择最优惠的价格、最优质的服务。</span>
      <div class="b-flex b-flex-row b-justify-center">
        <div class="module-line1">
          <div class="module-item b-flex b-flex-row b-align-centenr">
            <img
              src="https://image.ceekee.com/pc/secondwebsite/home_logo_xiecheng.png"
              class="icon"
            />
            <div class="detail">
              <span>携程：</span>
              携程c端价格直接同步，包括立减活动，十亿豪补，携程高级别会员价格
            </div>
          </div>
          <div class="module-item b-flex b-flex-row b-align-centenr">
            <img src="https://image.ceekee.com/pc/secondwebsite/home_logo_meituan.png" class="icon" />
            <div class="detail">
              <span>美团：</span>
              美团c端价格直接同步，包括美团c端的立减活动，美团会员级别对应折扣，最高享受85折，并且可以累计个人积分
            </div>
          </div>
        </div>
        <div class="module-line2">
          <div class="module-item b-flex b-flex-row b-align-centenr">
            <img src="https://image.ceekee.com/pc/secondwebsite/home_logo_huazhu.png" class="icon" />
            <div class="detail">
              <span>华住：</span>
              华住个人会员与企业会员打通，同步享受华住积分以及会员级别折扣价，每次预订实现最低价预订
            </div>
          </div>
          <div class="module-item b-flex b-flex-row b-align-centenr">
            <img
              src="https://image.ceekee.com/pc/secondwebsite/home_logo_donghang.png"
              class="icon"
            />
            <div class="detail">
              <span>东航：</span>
              东航NDC接口打通，东航官网价格以及产品、服务全部同步，获取专供渠道机票，全舱95折
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scene b-flex b-flex-column b-align-centenr">
      <div class="scene-title">Tripwise差旅场景流程</div>
      <img src="https://image.ceekee.com/pc/secondwebsite/home_liucheng.png" class="secne-img"/>
    </div>
    <div class="other-scene content b-flex b-flex-column b-align-centenr">
      <div class="other-scene-title">其他场景管控</div>
      <div class="left-title">其他场景</div>
      <div class="b-flex b-flex-column b-justify-center">
        <div class="other-scene-info">
          <span class="type">1.支持多场景化：</span>多场景自定义添加，公交、地铁、停车费、餐饮等；
        </div>
        <div class="other-scene-info">
          <span class="type">2.支持多场景管控：</span>添加商户、预算管理、最高限额、使用范围等；
        </div>
        <div class="other-scene-info">
          <span class="type">3.支付多场景支付解决方案：</span>行政采购场景、加班/高管用餐场景、备用金场景等；
        </div>
      </div>
      <img class="other-scene-img" src="https://image.ceekee.com/pc/secondwebsite/home_guankong.png" />
    </div>
    <div class="other-flow b-flex b-flex-column b-align-centenr">
      <div class="value-title">其他场景流程</div>
      <img class="value-img" src="https://image.ceekee.com/pc/secondwebsite/home_qitaliucheng.png?v=1" />
    </div>
    <div class="tripwise-value content b-flex b-flex-column b-align-centenr">
      <div class="value-title">Tripwise 价值</div>
      <div class="b-flex b-flex-row">
        <div class="value-item item-margin">
          <div class="item-title b-flex b-align-end">
            <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/home_value_yuangong.png" />
            <span class="lable">员工</span>
          </div>
          <div class="intro b-flex b-flex-column b-justify-center">
            <span class=' b-flex b-justify-center'>免垫资 免报销 免贴票</span>
            <span class=' b-flex b-justify-center'>一站式预订</span>
          </div>
        </div>
        <div class="value-item item-margin">
          <div class="item-title b-flex b-align-end">
            <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/home_value_xingzheng.png" />
            <span class="lable">行政</span>
          </div>
          <div class="intro b-flex b-flex-column b-justify-center">
            <span class=' b-flex b-justify-center'>统一预订，减轻工作压力，</span>
            <span class=' b-flex b-justify-center'>不需要多方比价</span>
          </div>
        </div>
        <div class="value-item item-margin">
          <div class="item-title b-flex b-align-end">
            <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/home_value_caiwu.png" />
            <span class="lable">财务</span>
          </div>
          <div class="intro b-flex b-flex-column b-justify-center">
            <span class=' b-flex b-justify-center'>统一结算，数据合规透明，</span>
            <span class=' b-flex b-justify-center'>避免大量发票审核</span>
          </div>
        </div>
        <div class="value-item">
          <div class="item-title b-flex b-align-end">
            <img class="icon" src="https://image.ceekee.com/pc/secondwebsite/home_value_guanli.png" />
            <span class="lable">管理者</span>
          </div>
          <div class="intro b-flex b-flex-column b-justify-center">
            <span class=' b-flex b-justify-center'>统一管控，成本节省</span>
            <span class=' b-flex b-justify-center'>差旅效率提升</span>
          </div>
        </div>
      </div>
    </div>
    <div class="statistics">
      <img src="https://image.ceekee.com/pc/secondwebsite/home_image02.png" class="img" />
      <div class="content">
        <div class="bg b-flex b-flex-row b-align-centenr b-justify-center">
          <div class="item item-margin b-flex b-flex-column">
            <div class="b-flex b-justify-center">
              <span class="icon tripwise-website icon-home_xiazailiang"></span>
            </div>
            <div class="b-flex b-justify-center label">
              下载使用量
            </div>
            <div class="b-flex b-justify-center count">
              2763812
            </div>
          </div>
          <div class="item item-margin b-flex b-flex-column">
            <div class="b-flex b-justify-center">
              <span class="icon tripwise-website icon-home_kehuhezuo"></span>
            </div>
            <div class="b-flex b-justify-center label">
              客户合作
            </div>
            <div class="b-flex b-justify-center count">
              3000+
            </div>
          </div>
          <div class="item item-margin b-flex b-flex-column">
            <div class="b-flex b-justify-center">
              <span class="icon tripwise-website icon-home_fuwuqiye"></span>
            </div>
            <div class="b-flex b-justify-center label">
              服务企业
            </div>
            <div class="b-flex b-justify-center count">
              12920
            </div>
          </div>
          <div class="item item-margin b-flex b-flex-column">
            <div class="b-flex b-justify-center">
              <span class="icon tripwise-website icon-home_fuwurenshu"></span>
            </div>
            <div class="b-flex b-justify-center label">
              服务人数
            </div>
            <div class="b-flex b-justify-center count">
              939000
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="link b-flex b-flex-column b-align-centenr">
      <div class="title">
        Tripwise系统广泛链接
      </div>
      <div class="detail b-flex b-flex-column b-align-centenr">
        <div>可通过集采数据的嵌入，进行数据实时同步，实现数字化流程一站式操作；</div>
        <div>数字化流程效率提升超过<span class="discount">80%</span>，释放无效工作时间 <span class="discount">60%</span>，合规性管控<span class="discount">100%</span></div>
      </div>
      <div class="link-oa b-flex b-flex-row">
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_dingding.png" /></div>
          <div class="text">钉钉</div>
        </div>
        <div class="link-item link-margin">
          <div><img style="height:60px;width:72px" src="https://image.ceekee.com/pc/secondwebsite/logo_qiwei.png" /></div>
          <div class="text">企业微信</div>
        </div>
        <div class="link-item link-margin">
          <div><img style="height:60px;width:74px" src="https://image.ceekee.com/pc/secondwebsite/logo_feishu.png" /></div>
          <div class="text">飞书</div>
        </div>
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_fanwei.png" /></div>
          <div class="text">泛微</div>
        </div>
      </div>
      <div class="link-oa b-flex b-flex-row">
        <div class="link-item link-margin">
          <div><img style="height:60px;width:177px" src="https://image.ceekee.com/pc/secondwebsite/logo_lanling.png" /></div>
          <div class="text">蓝凌</div>
        </div>
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_zhiyuan.png" /></div>
          <div class="text">致远</div>
        </div>
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_yunzhijia.png" /></div>
          <div class="text">云之家</div>
        </div>
        <div class="link-item link-margin">
          <div><img style="height:60px;width:138px" src="https://image.ceekee.com/pc/secondwebsite/logo_jindieyun.png" /></div>
          <div class="text">金蝶</div>
        </div>
      </div>
      <div class="b-flex b-flex-row">
        <div class="link-item link-margin">
          <div><img style="height:60px;width:90px" src="https://image.ceekee.com/pc/secondwebsite/logo_yongyou.png" /></div>
          <div class="text">用友</div>
        </div>
        <div class="link-item link-margin">
          <div><img style="height:60px;width:133px" src="https://image.ceekee.com/pc/secondwebsite/logo_haotian.png" /></div>
          <div class="text">神州浩天</div>
        </div>
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_meike.png" /></div>
          <div class="text">每刻</div>
        </div>
        <div class="link-item link-margin">
          <div><img class="img" src="https://image.ceekee.com/pc/secondwebsite/logo_huilianyi.png" /></div>
          <div class="text">汇联易</div>
        </div>
      </div>
    </div>
    <div class="customer content b-flex b-flex-column b-align-centenr">
      <div class="customer-title">合作客户</div>
      <div class="row-margin b-flex b-flex-row">
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_maiwei.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_keda.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_sibichi.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_rongxin.png"/>
        <img class="customer-item" src="https://image.ceekee.com/pc/secondwebsite/logo_mengbaihe.png"/>
      </div>
      <div class="row-margin b-flex b-flex-row">
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_ziguang.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_yitong.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_boen.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_jinguan.png"/>
        <img class="customer-item" src="https://image.ceekee.com/pc/secondwebsite/logo_sunpowei.png"/>
      </div>
      <div class="row-margin b-flex b-flex-row">
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_shenzhung.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_langrun.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_qingdao.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_tianyoude.png"/>
        <img class="customer-item" src="https://image.ceekee.com/pc/secondwebsite/logo_pushi.png"/>
      </div>
      <div class="b-flex b-flex-row">
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_harmo.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_huayun.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_juxing.png"/>
        <img class="customer-item customer-margin" src="https://image.ceekee.com/pc/secondwebsite/logo_beikang.png"/>
        <img class="customer-item" src="https://image.ceekee.com/pc/secondwebsite/logo_aixin.png"/>
      </div>
    </div>
    <tripwiseBottom></tripwiseBottom>
  </div>
</template>

<script>
import tripwiseHeader from "@/components/header";
import tripwiseBottom from "@/components/bottom";
export default {
  components: {
    tripwiseHeader,
    tripwiseBottom
  },
  methods:{
    toGet(){
      this.$router.push("/apply");
    }
  }
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  overflow: hidden;
  position: relative;
  .bannerBg {
    width: 100%;
  }
  .app-index {
    position: absolute;
    left: 20%;
    top: 20%;
    width: 22.2%;
    z-index: 9;
  }
  .banner-intro {
    position: absolute;
    top: 25%;
    left: 48%;
    width: 21.5%;
    color: #fff;
    .customer-info {
      margin-bottom: 60px;
      img {
        width: 100%;
      }
    }
    .button1 {
      width: 168px;
      height: 47px;
      background: #ffffff;
      box-shadow: 1px 1.7px 43px 0px rgba(21, 113, 179, 0.3);
      border-radius: 4px;
      font-size: 16px;
      color: #0376f7;
      cursor: pointer;
    }
    .button2 {
      width: 168px;
      height: 47px;
      background: rgba(0, 0, 0, 0);
      border: 1px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      margin-left: 20px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }
}
.content {
  background: #fff;
  width: 100%;
}
.title {
  margin-top: 76px;
  font-size: 40px;
  color: #000000;
  font-weight: 600;
}
.sub-title {
  margin: 120px 0 100px;
  font-size: 32px;
  color: #000000;
  font-weight: 600;
}
.other-title {
  margin: 120px 0 40px;
  font-size: 32px;
  color: #000000;
  font-weight: 600;
}
.travel {
  .travel-item {
    width: 260px;
    height: 300px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px rgba(187, 216, 250, 0.2);
    padding: 60px 40px;
    border-radius: 10px;
    .travel-title {
      font-size: 24px;
      line-height: 24px;
      color: #1e2046;
      font-weight: 600;
    }
    .travel-jipiao {
      margin-top: 96px;
      width: 108px;
      height: 60px;
    }
    .travel-jiudian {
      margin-top: 76px;
      width: 45px;
      height: 80px;
    }
    .travel-huoche {
      margin-top: 96px;
      width: 59px;
      height: 60px;
    }
    .travel-yongche {
      margin-top: 96px;
      width: 73px;
      height: 59px;
    }
    .travel-chaibiao {
      margin-top: 96px;
      width: 44px;
      height: 60px;
    }
    .travel-shenpi {
      margin-top: 95px;
      width: 56px;
      height: 61px;
    }
    .travel-yusuan {
      margin-top: 94px;
      width: 62px;
      height: 62px;
    }
  }
  .travel-margin {
    margin-right: 55px;
  }
}
.travel-second-row {
  margin-top: 58px;
}
.other-view {
  width: 73%;
  .other-image {
    width: 100%;
  }
}
.process {
  margin-top: 100px;
  width: 100%;
  position: relative;
  .left-title {
    font-size: 120px;
    line-height: 120px;
    color: #000000;
    font-weight: 600;
    opacity: 0.05;
    position: absolute;
    left: 0;
    top: 180px;
  }
  .process-title {
    line-height: 32px;
  }
  .process-info {
    margin-top: 90px;
    img {
      width: 67.2%;
    }
  }
}
.resources {
  padding: 100px 0;
  background: #f7fbfe;
  margin-top: 100px;
  .resources-info {
    width: 29.1%;
    margin-right: 12.5%;
    .resources-title {
      font-size: 40px;
      color: #000000;
      line-height: 40px;
      font-weight: 600;
      margin-bottom: 40px;
      margin-left: 20px;
    }
    .resource-detail {
      margin-bottom: 20px;
      width: 550px;
      .resources-icon {
        height: 93px;
        width: 93px;
        margin-right: 5px;
      }
      .resources-content {
        font-size: 16px;
        color: #666;
        line-height: 24px;
        .product {
          font-weight: 600;
          color: #000;
        }
        .discount {
          font-size: 20px;
          color: #0376f7;
        }
      }
    }
  }
  .resource-img {
    width: 33.5%;
  }

}
.module {
  padding: 100px 0;
  position: relative;
  .module-title {
    font-size: 40px;
    color: #1d293f;
    letter-spacing: 2px;
    line-height: 40px;
    font-weight: 600;
    .title-color {
      color: #f72b03;
    }
    margin-bottom: 60px;
  }
  .module-intro {
    font-size: 18px;
    color: #666666;
    line-height: 32px;
    font-weight: 600;
  }
  .module-line1 {
    z-index: 1;
    margin-right: 10.4%;
    margin-top: 150px;
  }
  .module-line2 {
    z-index: 1;
    margin-top: 80px;
  }
  .module-item {
    width: 540px;
    height: 188px;
    background: #ffffff;
    box-shadow: 0px 2px 32px 0px rgba(14, 86, 124, 0.07);
    border-radius: 20px;
    margin-bottom: 30px;
    padding: 36px 30px;
    .icon {
      height: 116px;
      width: 116px;
      margin-right: 40px;
    }
    .detail {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
      font-weight: 600;
      .supplier {
        color: #000000;
      }
    }
  }
  .right-back {
    position:absolute;
    right: 0;
    height: 100%;
    width: 26%;
    z-index: 0;
    background: url(https://image.ceekee.com/pc/secondwebsite/home_image.png) no-repeat;
  }
}
.scene {
  background: #f7fbfe;
  padding: 100px 0;
  font-size: 24px;
    color: #666666;
    line-height: 24px;
    font-weight: 600;
  .scene-title {
    margin-bottom: 40px;
    font-size: 40px;
    color:#1D293F;
  }
  .secne-img {
    width: 94%;
  }
}
.other-scene {
  padding: 100px 0;
  .other-scene-title{
    font-size: 40px;
    color: #1D293F;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 30px;
  }
  position: relative;
  .left-title {
    font-size: 120px;
    line-height: 120px;
    color: #000000;
    font-weight: 600;
    opacity: 0.05;
    position: absolute;
    left: 0;
    top: 180px;
  }
  .other-scene-info{
    font-size: 16px;
    color: #666666;
    line-height: 32px;
    .type{
      color: #000000;
      font-weight: 600;
    }
    
  }
  .other-scene-img {
    margin-top: 70px;
    width:64.5%;
  }
}
.other-flow {
  padding: 100px 0;
  background: #F7FBFE;
  .value-title{
    font-size: 40px;
    color: #1D293F;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 80px;
  }
  .value-img{
    
    width: 69.5%;
  }
}
.tripwise-value{
  padding: 100px 0;
  .value-title{
    font-size: 40px;
    color: #1D293F;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 90px;
  }
  .value-item{
    width: 300px;
    height: 320px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(14,86,124,0.16);
    border-radius: 20px;
    padding: 40px;
    .item-title{
      .icon{
        height: 34px;
        width: 31px;
        margin-right: 30px;
      }
      .lable {
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        font-weight: 600;
      }
    }
    .intro{
        margin-top: 60px;
        font-size: 16px;
        color: #666666;
        text-align: center;
        line-height: 24px;
        font-weight: 600;
      }
  }

@media screen and (max-width: 1400px) {
  .value-item{
    width: 260px;
    height: 270px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(14,86,124,0.16);
    border-radius: 20px;
    padding: 20px;
    .item-title{
      .icon{
        height: 34px;
        width: 31px;
        margin-right: 20px;
      }
      .lable {
        font-size: 20px;
        color: #000000;
        line-height: 20px;
        font-weight: 600;
      }
    }
    .intro{
        margin-top: 60px;
        font-size: 16px;
        color: #666666;
        text-align: center;
        line-height: 24px;
        font-weight: 600;
      }
  }
}

  .item-margin{
      margin-right:40px;
    }
}
.statistics {
  position: relative;
  .content{
    padding-top: 224px;
    .bg {
      width: 100%;
      height: 280px;
      background: url(https://image.ceekee.com/pc/secondwebsite/bg.png) no-repeat;
    }
    .item {
      color: #FFFFFF;
      .icon {
        font-size: 44px;
      }
      .label{
        margin-top: 35px;
        font-size: 18px;
      }
      .count{
        font-size: 30px;
        line-height: 30px;
        font-weight: 400;
        margin-top: 20px;
      }
    }
    @media screen and (max-width: 1400px) {
      .item {
      color: #FFFFFF;
      .icon {
        font-size: 40px;
      }
      .label{
        margin-top: 30px;
        font-size: 18px;
      }
      .count{
        font-size: 30px;
        line-height: 30px;
        font-weight: 400;
        margin-top: 20px;
      }
    }
    .item-margin{
      margin-right: 160px!important;
    }
    }
    .item-margin{
      margin-right: 200px;
    }
  }
  .img {
    position: absolute;
    height: 316px;
    width: 468px;
    z-index: 1;
    right: 0;
    top: 0;
  }
}
.link{
  padding: 100px 0;
  background: #F7FBFE;
  .title{
    font-size: 40px;
    color: #1D293F;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 60px;
  }
  .detail{
    font-size: 16px;
    color: #666666;
    line-height: 32px;
    font-weight: 600;
    margin-bottom: 80px;
    .discount{
      font-size: 20px;
      color: #0376F7;
      line-height: 32px;
      font-weight: 600;
    }
  }
  .link-oa{
    margin-bottom: 60px;
  }
  .link-item{
    width: 240px;
    height: 200px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(14,86,124,0.16);
    border-radius: 20px;
    padding: 48px 40px 38px;
    .img{
      height: 60px;
      width: 60px;
    }
    .text{
      margin-top: 30px;
      font-size: 24px;
      color: #1D293F;
      line-height: 24px;
      font-weight: 600;
    }
  }
  .link-margin{
    margin-left: 20px;
  }
}
.customer{
  padding: 100px 0;
  .customer-title{
    font-size: 40px;
    color: #1D293F;
    line-height: 40px;
    font-weight: 600;
    margin-bottom: 80px;
  }
  .row-margin{
    margin-bottom: 54px;
  }
  .customer-item{
    height: 137px;
    width:218px;
  }
   .customer-margin{
     margin-right: 30px;
   }
}
</style>